/**
 * Los botones de acción de la plataforma: mismo alto (40 px) y mismo redondeo
 * (rounded-lg) en cualquier módulo, sea de formulario, edición, creación o
 * cancelar. Solo cambia el color según lo que hace el botón.
 *
 * Todos llevan la animación de elevar al pasar el cursor (A-07).
 *
 * Uso: className={estiloDeBoton('primario')} o con una clase extra
 * (`estiloDeBoton('secundario', 'w-full')`).
 *
 * - primario: la acción principal (Guardar, Crear, Editar, Enviar).
 * - secundario: lo que cancela o regresa (Cancelar, Volver, Duplicar). Va a la
 *   IZQUIERDA del primario.
 * - peligro: lo destructivo (Eliminar, Rechazar).
 * - exito: confirmar lo que se aprueba (Aprobar, Contratar).
 *
 * Los botones de solo ícono, las pestañas, los chips de filtro y las tarjetas
 * que funcionan como botón no son botones de acción: no usan esto.
 */
const BASE =
  'elevar inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50'

const VARIANTES = {
  primario: 'bg-[#253579] text-white hover:bg-[#253579]/80',
  secundario: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  peligro: 'bg-[#F8E3E3] text-[#EF4444] hover:opacity-90',
  exito: 'bg-green-600 text-white hover:bg-green-700',
} as const

export type VarianteDeBoton = keyof typeof VARIANTES

export const estiloDeBoton = (variante: VarianteDeBoton, extra = '') =>
  `${BASE} ${VARIANTES[variante]}${extra ? ` ${extra}` : ''}`
